import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProcessosComponent } from './processos.component';
import { PoModule } from '@po-ui/ng-components';

@NgModule({
  declarations: [
    ProcessosComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PoModule
  ],
  exports: [
    ProcessosComponent
  ]
})
export class ProcessosModule { }


